import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CryptoService {
  base64UrlDecode(base64url: string): Uint8Array {
    base64url = base64url.replace(/-/g, "+").replace(/_/g, "/");
    const pad = base64url.length % 4;
    if (pad) base64url += "=".repeat(4 - pad);
    const raw = window.atob(base64url);
    return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
  }

  base64UrlEncode(bytes: Uint8Array): string {
    let binary = "";
    bytes.forEach((b) => (binary += String.fromCharCode(b)));
    let base64 = window.btoa(binary);
    // Convert to base64url by replacing +, / and removing =
    return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }

  async decryptData(encrypted: string): Promise<string> {
    if (encrypted == null || encrypted == undefined || encrypted == "") {
      return "";
    }
    const raw = this.base64UrlDecode(encrypted);

    const iv = raw.slice(0, 12); // First 12 bytes as IV
    const ciphertext = raw.slice(12); // Remaining is ciphertext

    const keyRaw = new TextEncoder().encode("DlNRLN8uRK5tFW393jVjAhpoJ5r2Yj3r"); // 32 bytes for AES-256
    const key = await crypto.subtle.importKey("raw", keyRaw, { name: "AES-GCM" }, false, ["decrypt"]);

    try {
      const decrypted = await crypto.subtle.decrypt({ name: "AES-GCM", iv }, key, ciphertext);
      return new TextDecoder().decode(decrypted);
    } catch (e) {
      return encrypted;
      // throw new Error("Decryption failed: " + e);
    }
  }

  async encryptData(plainText: string): Promise<string> {
    if (plainText == null || plainText == undefined || plainText == "") {
      return "";
    }

    const iv = crypto.getRandomValues(new Uint8Array(12)); // 12 bytes IV

    const keyRaw = new TextEncoder().encode("DlNRLN8uRK5tFW393jVjAhpoJ5r2Yj3r"); // 32 bytes key
    const key = await crypto.subtle.importKey("raw", keyRaw, { name: "AES-GCM" }, false, ["encrypt"]);

    const encodedText = new TextEncoder().encode(plainText);

    try {
      const encrypted = await crypto.subtle.encrypt({ name: "AES-GCM", iv }, key, encodedText);

      // Combine IV + ciphertext
      const combined = new Uint8Array(iv.length + encrypted.byteLength);
      combined.set(iv, 0);
      combined.set(new Uint8Array(encrypted), iv.length);

      // Base64Url encode
      return this.base64UrlEncode(combined);
    } catch (e) {
      throw new Error("Encryption failed: " + e);
    }
  }

  isProbablyEncrypted(input: string): boolean {
    if (!input || input.trim() === "") {
      return false;
    }

    try {
      const decoded = this.base64UrlDecode(input);

      // Minimum length check: IV (12 bytes) + some ciphertext (>0)
      if (decoded.length <= 12) {
        return false;
      }

      return true;
    } catch (e) {
      // If base64Url decoding fails, it's probably not encrypted
      return false;
    }
  }
}
